
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'InformativeModal',
})
export default class Informative extends Vue {
  @Prop({}) public phrase: string;
}
